export const RuleEnforcementType = {
  WARNING: 'warning',
  BLOCKING: 'blocking',
  DISABLED: 'disabled',
};
